import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-email-field',
  templateUrl: './email-field.component.html',
  styleUrls: ['./email-field.component.scss']
})
export class EmailFieldComponent {
  // Named `control` (not `formControl`) so it does not collide with Angular's
  // FormControlDirective on the host element, which would require a
  // ControlValueAccessor and throw NG01203. The inner native <input> does the
  // real form binding; this input just hands the FormControl in.
  @Input() control: any;

  onEmailKeyDown(event: KeyboardEvent): void {
    // Prevent space key from being entered
    if (event.key === ' ') {
      event.preventDefault();
    }
  }

  onEmailInput(value: string): void {
    if (value) {
      // Convert to lowercase
      const cleanedEmail = value.toLowerCase();
      this.control.setValue(cleanedEmail, { emitEvent: false });
    }
  }

  onEmailBlur(): void {
    if (this.control.value) {
      // Final cleanup and validation on blur
      const cleanedEmail = this.control.value.toLowerCase();

      // Validate email against regex pattern
      const emailRegex = /^[A-Z0-9a-z._%+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,20}$/;

      if (emailRegex.test(cleanedEmail)) {
        this.control.setValue(cleanedEmail);
      } else {
        // If invalid, still set the cleaned value (lowercase)
        this.control.setValue(cleanedEmail);
      }
    }
  }
}
